import React from 'react'

const MainLayout = ({ children }) => (
  <>
      {children}
  </>  
)

export default MainLayout